angular.module('picmonicpublic').component('challengeComponent', {
    templateUrl: '/templates/public/pages/challenge/challenge.html',
    bindings: {
        $transition$: '<'
    },
    controller: ['$interval', 'UserService', 'ChallengesResource', 'MetaService', function($interval, UserService, ChallengesResource, MetaService){
        var ctrl = this;
        var interval;
        var stateParams = ctrl.$transition$.params('to');
        ctrl.UserService = UserService;

        ctrl.challenge = ChallengesResource.get({slug: stateParams.slug});
        ctrl.challenge.$promise.then(function() {
            MetaService.replace('%FNAME%', ctrl.challenge.owner.first_name);
            MetaService.replace('%LNAME%', ctrl.challenge.owner.last_name);
            MetaService.replace('%QUIZNAME%', ctrl.challenge.name);

            ctrl.expiresIn = ctrl.challenge.ends_at - Math.floor(Date.now()/1000);
            if (ctrl.expiresIn) {
                interval = $interval(function(){
                    ctrl.expiresIn--;
                }, 1000, ctrl.expiresIn);
            }
        });

        ctrl.acceptChallenge = function() {
            if (UserService.user.user_id) {
                window.location = '/quiz/challenge/'+ctrl.challenge.slug;
            } else {
                UserService.showRegisterModal(false, '/quiz/challenge/'+ctrl.challenge.slug, false, 'Unlock my FREE Quiz');
            }
        };

        ctrl.$onDestroy = function(){
            if (interval) {
                $interval.cancel(interval);
            }
        };
    }]
});